import React, { memo, useMemo } from 'react'

import i18n from '@batical/i18n'
import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'
import { Box } from '@mui/material'

import { ResultTextStyled, ResultTextUnit, ResultTextValue, ViewLineResult } from './LineStyleComponent'
import { batikalColor } from '../Colors'

export type ResultLineProps = {
  calculCode: CalculCodeStateKeys
  variableName: string
  error?: string
  unit?: string
  trunc?: number
  title?: string
  doCalcul?: boolean
  first?: boolean
  last?: boolean
}
const ResultLine = ({
  title,
  calculCode,
  variableName,
  error,
  unit,
  trunc = 2,
  doCalcul = false,
  first = false,
  last = false
}: ResultLineProps) => {
  const value = useContextValue(variableName, calculCode, doCalcul)[0]
  const invalidated = false //useContextBoolean('invalidated', calculCode)[0]
  const text = useMemo(() => {
    if (title) {
      return i18n.t(title)
    } else {
      return i18n.t(`${calculCode}_${variableName}`)
    }
  }, [calculCode, title, variableName])
  return (
    <ResultLineManual
      title={text}
      value={value}
      error={error}
      unit={unit}
      trunc={trunc}
      invalidated={invalidated}
      first={first}
      last={last}
    />
  )
}

export type ResultLineManualProps = {
  value: number
  error?: string
  unit?: string
  trunc?: number
  title?: string
  invalidated?: boolean
  first?: boolean
  last?: boolean
}
export const ResultLineManual = ({
  title,
  value,
  error,
  unit,
  trunc = 2,
  invalidated = false,
  first = false,
  last = false
}: ResultLineManualProps) => {
  return (
    <ViewLineResult first={first} last={last} justifyContent="space-between" alignItems="center" sx={{ backgroundColor: batikalColor }}>
      <Box sx={{ flex: 1 }}>
        <ResultTextStyled>{title}</ResultTextStyled>
      </Box>
      {invalidated && (
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <ResultTextValue>{i18n.t('invalidatedCalcul')}</ResultTextValue>
        </Box>
      )}
      {!invalidated && (
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          {!isNaN(value) && value != null && <ResultTextValue>{+value.toFixed(trunc)}</ResultTextValue>}
          {(isNaN(value) || value == null) && error && error.length > 0 && <ResultTextValue>{i18n.t(error)}</ResultTextValue>}
          {unit && unit.length > 0 && <ResultTextUnit>{unit}</ResultTextUnit>}
        </Box>
      )}
    </ViewLineResult>
  )
}

export default memo(ResultLine)
